import { useState, useEffect, useContext } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { TextField, Chip } from '@mui/material';
import { OpenSwal, notistackSnakebar } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormControlLabel } from '@mui/material';
import { useSnackbar } from 'notistack';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Paper from '@mui/material/Paper';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InputLabel from '@mui/material/InputLabel';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { url_fetch_vacation_lists, url_vacation_setting, url_delete_vacation_setting } from '../../RoutesMap';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Swal from 'sweetalert2';

import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Checkbox from '@mui/material/Checkbox';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { AuthContext } from '../../Context/AuthProvider';
import { apiWithAuth } from '../../Services/Axios/axios';

dayjs.extend(utc)
dayjs.extend(timezone)


export default function VacationSetting() {
    const { currentUser } = useContext(AuthContext);
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const [highlightedDays, setHighlightedDays] = useState([]);
    const navigate = useNavigate();

    const iti_user_timezone = currentUser['custom:user_timezone'];
    dayjs.tz.setDefault(iti_user_timezone);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    // const [DateCalendarInitialValue, SetDateCalendarInitialValue] = useState(null);
    const [DateCalendarLoadingStatus, SetDateCalendarLoadingStatus] = useState(true);
    const [VacationListData, SetVacationListData] = useState([]);
    const [VacationListsLoadingStatus, SetVacationListsLoadingStatus] = useState(true);
    // const [DateCalendarCurrentYearMonth, SetDateCalendarCurrentYearMonth] = useState(dayjs().format('YYYY-MM-DD'));
    const [DateCalendarCurrentDate, SetDateCalendarCurrentDate] = useState(dayjs.tz());
    const [TriggerVacationAndDateCalender, SetTriggerVacationAndDateCalender] = useState(new Date());  //just trigger


    //Dialog Box:
    const [VactionDialogBoxViewStatus, SetVactionDialogBoxViewStatus] = useState(false);
    const [DialogPartialDayCheckBoxStatus, SetDialogPartialDayCheckBoxStatus] = useState(false);
    const [DialogVacationSelectedId, SetDialogVacationSelectedId] = useState('');

    const [DialogVacationTitleValue, SetDialogVacationTitleValue] = useState("");
    const [DialogVacationHeaderName, SetDialogVacationHeaderName] = useState("");
    const [DialogVacationTitleErrorMsg, SetDialogVacationTitleErrorMsg] = useState(false);
    const [DialogStartDateValue, SetDialogStartDateValue] = useState(null);
    const [DialogStartTimeMinValue, SetDialogStartTimeMinValue] = useState(null);
    const [DialogStartDateErrorMsg, SetDialogStartDateErrorMsg] = useState(false);
    const [DialogEndDateValue, SetDialogEndDateValue] = useState(null);
    // const [DialogEndDateMinValue, SetDialogEndDateMinValue] = useState(null);
    const [DialogEndDateErrorMsg, SetDialogEndDateErrorMsg] = useState(false);

    const [DialogFromTimeValue, SetDialogFromTimeValue] = useState(null);
    const [DialogFromTimeErrorMsg, SetDialogFromTimeErrorMsg] = useState(false);
    const [DialogToTimeValue, SetDialogToTimeValue] = useState(null);
    const [DialogToTimeErrorMsg, SetDialogToTimeErrorMsg] = useState(false);


    const [DialogAddVactionButtonLoadingStatus, SetDialogAddVactionButtonLoadingStatus] = useState(false);

    useEffect(() => {
        if (!DialogAddVactionButtonLoadingStatus) {
            SetDateCalendarLoadingStatus(true);
            let payload = {
                status: 'get_vacation_dates'
            };
            apiWithAuth.post(url_fetch_vacation_lists, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                SetDateCalendarLoadingStatus(false);
                if (response.data.status) {
                    setHighlightedDays(response.data.vacation_all_days);
                } else if (response.data.status === false && response.data.message === "Token Expired") {
                    OpenSwal('Token_error', navigate);
                } else {
                    OpenSwal('Axios_error', response.data.message);
                }
            }).catch(response => {
                SetDateCalendarLoadingStatus(false);
                OpenSwal('Axios_error', response.message);
            });
        }
    }, [TriggerVacationAndDateCalender]);


    useEffect(() => {
        if (!DialogAddVactionButtonLoadingStatus) {
            SetVacationListsLoadingStatus(true);
            let payload = {
                status: 'get_vacation_lists_by_selected_date',
                current_selected_date: DateCalendarCurrentDate.format('YYYY-MM-DD')
            };
            apiWithAuth.post(url_fetch_vacation_lists, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {

                if (response.data.status) {
                    SetVacationListData(response.data.vacation_datas);
                    if (response.data.vacation_datas.length === 0) SetVacationListsLoadingStatus(null);
                    else SetVacationListsLoadingStatus(false);
                } else if (response.data.status === false && response.data.message === "Token Expired") {
                    SetVacationListsLoadingStatus(false);
                    OpenSwal('Token_error', navigate);
                } else {
                    SetVacationListsLoadingStatus(false);
                    OpenSwal('Axios_error', response.data.message);
                }
            }).catch(response => {
                SetVacationListsLoadingStatus(false);
                OpenSwal('Axios_error', response.message);
            });
        }
    }, [DateCalendarCurrentDate, TriggerVacationAndDateCalender]);



    const OpenDialogBox = () => {
        let selected_current_date = DateCalendarCurrentDate;
        SetDialogVacationHeaderName('add');
        SetDialogVacationSelectedId('');
        SetDialogVacationTitleValue('');
        SetDialogVacationTitleErrorMsg(false);
        SetDialogStartTimeMinValue(selected_current_date);
        SetDialogStartDateValue(selected_current_date);
        SetDialogStartDateErrorMsg(false);
        // SetDialogEndDateMinValue(current_date.add('1', 'day'));
        SetDialogEndDateValue(null);
        SetDialogEndDateErrorMsg(false);

        SetDialogPartialDayCheckBoxStatus(false);
        CheckFromDateMindate(selected_current_date);
        // if (check_is_current_date) {
        let current_date = dayjs.tz();
        SetDialogFromTimeValue(current_date);
        SetDialogToTimeValue(current_date.add(1, 'minute'));
        // } else {
        //     SetDialogFromTimeValue(null);
        //     SetDialogToTimeValue(null);
        // }
        SetDialogFromTimeErrorMsg(false);
        SetDialogToTimeErrorMsg(false);

        SetVactionDialogBoxViewStatus(true);
    }
    // console.log(DialogVacationTitleValue);
    const OpenDialogBoxUpdate = (vacation_id, vacation_title, start_date, end_date, vacation_partial_day, from_time, to_time) => {
        let current_date = dayjs.tz();
        // console.log(dayjs(start_date))
        SetDialogVacationHeaderName('update');
        SetDialogVacationTitleErrorMsg(false);
        SetDialogStartTimeMinValue(current_date);
        SetDialogStartDateValue(dayjs(start_date));
        SetDialogStartDateErrorMsg(false);
        SetDialogVacationTitleValue(vacation_title);
        SetDialogVacationSelectedId(vacation_id);

        CheckFromDateMindate(dayjs(start_date));
        if (vacation_partial_day === 'Yes') {
            SetDialogPartialDayCheckBoxStatus(true);
            SetDialogFromTimeValue(dayjs(from_time));
            SetDialogFromTimeErrorMsg(false);
            SetDialogToTimeValue(dayjs(to_time));
            SetDialogToTimeErrorMsg(false);

            //default values
            SetDialogEndDateValue(dayjs(start_date).add('1', 'day'));
            SetDialogEndDateErrorMsg(false);
        } else {
            SetDialogPartialDayCheckBoxStatus(false);

            SetDialogEndDateValue(dayjs(end_date));
            SetDialogEndDateErrorMsg(false);

            //default values
            SetDialogFromTimeValue(current_date);
            SetDialogFromTimeErrorMsg(false);
            SetDialogToTimeValue(current_date.add(1, 'minute'));
            SetDialogToTimeErrorMsg(false);
        }


        SetVactionDialogBoxViewStatus(true);
    }
    const getDateTimePickerValidationMsg = (error) => {
        let msg = false;
        if (error === null) {
            msg = false;
        } else if (error === "disableFuture") {
            msg = 'You Choosed a Maximum Date';
        } else if (error === "minTime" || "maxTime" || "minDate" || "maxDate") {
            msg = 'You Choosed a ' + error;
        } else {
            msg = 'error:  ' + error;
        }
        return msg;
    }
    const CheckFromDateMindate = (value) => {
        // let get_result = dayjs.tz().isSame(value, 'day')
        // console.log(get_result);
        let return_status = false;
        if (dayjs.tz().format('YYYY-MM-DD') === value.format('YYYY-MM-DD')) {
            SetDialogStartTimeMinValue(dayjs.tz());
            return_status = true;
        } else {
            SetDialogStartTimeMinValue(null);
        }
        return return_status;
    }

    const OnChangeStartDate = (value) => {
        SetDialogStartDateValue(value);
        CheckFromDateMindate(value);

    }

    const AddUpdateVacation = (status) => {
        let return_status = true;
        SetDialogVacationTitleErrorMsg(false);

        if (DialogVacationTitleValue.trim() === "") {
            SetDialogVacationTitleErrorMsg('Vacation Title is Required');
            return_status = false;
        }
        if (DialogStartDateErrorMsg !== false) {
            return_status = false;
        }
        if (DialogPartialDayCheckBoxStatus) {
            if (DialogFromTimeErrorMsg !== false || DialogToTimeErrorMsg !== false) {
                return_status = false;
            }
        } else {
            if (DialogEndDateValue) {
                if (isNaN(new Date(DialogEndDateValue))) {
                    return_status = false;
                    SetDialogEndDateErrorMsg('You Choosed a Invalid Date');
                } else {
                    if (DialogStartDateValue > DialogEndDateValue) {
                        return_status = false;
                        SetDialogEndDateErrorMsg('You Choosed a Minimum Date');
                    } else {
                        SetDialogEndDateErrorMsg(false);
                    }
                }
            } else {
                SetDialogEndDateErrorMsg('End Date Required');
                return_status = false;
            }
        }

        if (return_status) {
            SetDialogAddVactionButtonLoadingStatus(true);
            let payload = {
                vacation_id: DialogVacationSelectedId,
                vacation_title: DialogVacationTitleValue,
                vacation_start_date: DialogStartDateValue.format('YYYY-MM-DD'),
                vacation_end_date: (DialogEndDateValue) ? DialogEndDateValue.format('YYYY-MM-DD') : "",
                vacation_from_time: (DialogFromTimeValue) ? DialogFromTimeValue.format('hh:mm A') : "",
                vacation_to_time: (DialogToTimeValue) ? DialogToTimeValue.format('hh:mm A') : "",
                vacation_partial_day_status: DialogPartialDayCheckBoxStatus,
            };
            apiWithAuth.post(url_vacation_setting, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    SetVactionDialogBoxViewStatus(false);
                    // if (DateCalendarCurrentDate !== null) {
                    SetTriggerVacationAndDateCalender(new Date());  //trigger list load   
                    // }
                    notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: response.data.message, variant: 'success' });
                } else if (response.data.status === false && response.data.message === "Token Expired") {
                    OpenSwal('Token_error', navigate);
                } else {
                    OpenSwal('Axios_error', response.data.message);
                }
                SetDialogAddVactionButtonLoadingStatus(false);
            }).catch(response => {
                SetDialogAddVactionButtonLoadingStatus(false);
                OpenSwal('Axios_error', response.message);
            });
        }
    }


    const DeleteVacation = (vacation_id) => {
        Swal.fire({
            title: 'Remove Vacation',
            text: "Do you want to remove the vacation slot?",
            showCancelButton: true,
            icon: "error",
            iconColor: 'red',
            confirmButtonText: "Confirm",
            cancelButtonColor: '#f44336',
            confirmButtonColor: '#89B601',
            // cancelButtonText: "Cancel",
            color: appThemeColor,
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                apiWithAuth.post(url_delete_vacation_setting, {}, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                    if (response.data.status) {
                        SetTriggerVacationAndDateCalender(new Date());  //trigger list load
                        notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: response.data.message, variant: 'success' });
                    } else if (response.data.status === false && response.data.message === "Token Expired") {
                        OpenSwal('Token_error', navigate);
                    } else {
                        OpenSwal('Axios_error', response.data.message);
                    }
                    // SetDialogAddVactionButtonLoadingStatus(false);
                }).catch(response => {
                    // SetDialogAddVactionButtonLoadingStatus(false);
                    OpenSwal('Axios_error', response.message);
                });

            }
        });


    }

    function ServerDay(props) {
        const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
        const isSelected = !props.outsideCurrentMonth && highlightedDays.includes(props.day.format('YYYY-MM-DD'));
        return (
            <Badge key={props.day.toString()} overlap="circular" badgeContent={1} invisible={!isSelected} color="secondary" variant='dot' >
                <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
            </Badge>
        );
    }


    const GoBackSetting = () => {
        navigate('/Interpreter/App_Setting');
    }
    return (

        <Box  >

            <Box>
                <Grid container >
                    <Grid xs={10} sm={10} md={10}> <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >Vacation Settings</Typography> </Grid>
                    <Grid xs={2} sm={2} md={2}>
                        <Box sx={{ display: 'flex', justifyContent: 'right' }}> <Button startIcon={<ArrowBackIcon sx={{ mr: -1, fontSize: '2px' }} />} onClick={GoBackSetting} sx={{ textDecoration: 'underline', textTransform: 'none', color: appThemeColor }} >Back</Button> </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ position: 'absolute', left: 0, right: 0, mt: -2 }} >
                <Box sx={{ overflow: 'auto' }} >
                    <LocalizationProvider dateAdapter={AdapterDayjs}  >
                        <DateCalendar sx={{ height: 320 }}
                            loading={DateCalendarLoadingStatus}
                            value={DateCalendarCurrentDate}
                            disablePast

                            renderLoading={() => <DayCalendarSkeleton />}
                            onChange={(newValue) => SetDateCalendarCurrentDate(newValue)}
                            slots={{
                                day: ServerDay,
                            }}
                            slotProps={{
                                day: {
                                    highlightedDays
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                <Box mb={20} mt={1} mx={3}>
                    <Box display='flex' justifyContent='space-between'>

                        <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >List of Vacations</Typography>
                        <Button size='small' startIcon={<AddCircleOutlineOutlinedIcon />} color={appThemeSecondaryColor} variant="contained" sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={OpenDialogBox}>Add Vacation</Button>

                    </Box>
                    <Box mt={2}>


                        {VacationListsLoadingStatus === true && VacationListData.length === 0 ?
                            <Box display='flex' justifyContent='center' mt={2}>
                                <CircularProgress color={appThemeSecondaryColor} />
                            </Box>
                            :

                            VacationListsLoadingStatus === null ?
                                <Box mt={3}><Typography align='center' color={appThemeColor}>No vacations found!</Typography></Box> :
                                <Box >
                                    {VacationListData.map((data, index) => {
                                        return (
                                            <Paper sx={{ padding: 1, mt: 1 }} key={index}>
                                                <Box>
                                                    <Grid container >
                                                        <Grid xs={9.5} sm={10} md={10}>
                                                            {data.vacation_partial_day === 'Yes' ?
                                                                <Box><Box display='flex' alignItems='center'><Typography color={appThemeColor} variant='body2' sx={{ letterSpacing: -0.5 }}>{dayjs(data.vacation_start_date).format('MM/DD/YYYY')}</Typography><Chip label={<Typography variant='caption' >Partial day</Typography>} sx={{ ml: 0.8, height: 15, backgroundColor: '#89B601', color: '#fff', '& .MuiChip-label': { padding: '4px' } }} size='small' /></Box>
                                                                    <Typography color={appThemeColor} variant='body2' >{dayjs(data.vacation_start_time).format('hh:mm A') + ' - ' + dayjs(data.vacation_end_time).format('hh:mm A')}</Typography></Box> :
                                                                <Box display='flex' alignItems='center'><Typography color={appThemeColor} variant='body2' sx={{ whiteSpace: 'nowrap' }}>{dayjs(data.vacation_start_date).format('MM/DD/YYYY') + ' - ' + dayjs(data.vacation_end_date).format('MM/DD/YYYY')}</Typography></Box>}
                                                        </Grid>
                                                        <Grid xs={1.5} sm={1} md={1} > <EditOutlinedIcon sx={{ color: appThemeColor, cursor: 'pointer' }} onClick={() => OpenDialogBoxUpdate(data.vacation_id, data.vacation_title, data.vacation_start_date, data.vacation_end_date, data.vacation_partial_day, data.vacation_start_time, data.vacation_end_time)} /> </Grid>
                                                        <Grid xs={1} sm={1} md={1}  > <DeleteForeverOutlinedIcon color='error' sx={{ cursor: 'pointer' }} onClick={() => DeleteVacation(data.vacation_id)} /> </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box >
                                                    <Typography variant='h6' fontWeight='normal' color={appThemeColor}>{data.vacation_title}</Typography>
                                                </Box>
                                            </Paper>
                                        )
                                    })}
                                </Box>}
                    </Box>
                </Box>
            </Box>
            {VactionDialogBoxViewStatus && <Dialog onClose={() => SetVactionDialogBoxViewStatus(false)} open={VactionDialogBoxViewStatus} fullWidth sx={{ zIndex: 4 }} >
                <DialogTitle color={appThemeColor} variant='body1' fontWeight='bold' sx={{ pb: 0.5, textDecoration: 'underline' }}> {(DialogVacationHeaderName === 'add') ? 'Add Vacation' : 'Update vacation'} </DialogTitle>
                <DialogContent >
                    <Box>
                        <Box  >
                            <InputLabel htmlFor="vacation-title-input-box" > <Typography color={appThemeColor} variant='body2'>Vacation Title</Typography></InputLabel>
                            <TextField id='vacation-title-input-box' size='small' error={(DialogVacationTitleErrorMsg !== false)} autoComplete='off' helperText={DialogVacationTitleErrorMsg} fullWidth color={appThemeSecondaryColor} value={DialogVacationTitleValue} onChange={(evt) => SetDialogVacationTitleValue(evt.target.value)} />
                        </Box>
                        <Box mt={1}>

                            <LocalizationProvider dateAdapter={AdapterDayjs} >
                                <InputLabel htmlFor="vacation-start-date-input-box" ><Typography color={appThemeColor} variant='body2'>Start Date</Typography> </InputLabel>
                                <DatePicker slotProps={{ textField: { id: 'vacation-start-date-input-box', size: 'small', error: (DialogStartDateErrorMsg !== false), helperText: DialogStartDateErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}
                                    format='MM/DD/YYYY'
                                    disablePast

                                    value={DialogStartDateValue}
                                    onChange={(value) => OnChangeStartDate(value)}
                                    onError={(newError) => SetDialogStartDateErrorMsg(getDateTimePickerValidationMsg(newError))}
                                    maxDate={DialogPartialDayCheckBoxStatus ? null : (DialogEndDateValue === null) ? null : DialogEndDateValue.subtract(1, 'day')}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box display='flex' justifyContent='right' mt={1}>
                            <FormControlLabel label={<Typography variant='body2' color={appThemeColor}>partial day ?</Typography>} control={<Checkbox color={appThemeSecondaryColor} checked={DialogPartialDayCheckBoxStatus} onChange={(evt) => SetDialogPartialDayCheckBoxStatus(evt.target.checked)} />} />
                        </Box>
                        {DialogPartialDayCheckBoxStatus ?
                            <Box>
                                <Box mt={1}>

                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <InputLabel htmlFor="vacation-from-time-input-box" ><Typography color={appThemeColor} variant='body2'>From Time</Typography> </InputLabel>
                                        <TimePicker slotProps={{ textField: { id: 'vacation-from-time-input-box', size: 'small', error: (DialogFromTimeErrorMsg !== false), helperText: DialogFromTimeErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}


                                            minTime={DialogStartTimeMinValue}
                                            format='hh:mm A'
                                            value={DialogFromTimeValue}
                                            maxTime={DialogToTimeValue === null ? null : DialogToTimeValue.subtract(1, 'minute')}
                                            onChange={(value) => SetDialogFromTimeValue(value)}
                                            timeSteps={{ minutes: 1 }}
                                            onError={(newError) => SetDialogFromTimeErrorMsg(getDateTimePickerValidationMsg(newError))}
                                        />

                                    </LocalizationProvider>

                                </Box>
                                <Box mt={1}>

                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <InputLabel htmlFor="vacation-to-time-input-box" ><Typography color={appThemeColor} variant='body2'>To Time</Typography> </InputLabel>
                                        <TimePicker slotProps={{ textField: { id: 'vacation-to-time-input-box', size: 'small', error: (DialogToTimeErrorMsg !== false), helperText: DialogToTimeErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}

                                            timeSteps={{ minutes: 1 }}
                                            // disablePast
                                            format='hh:mm A'
                                            value={DialogToTimeValue}
                                            minTime={DialogFromTimeValue === null ? null : DialogFromTimeValue.add(1, 'minute')}
                                            onChange={(value) => SetDialogToTimeValue(value)}
                                            onError={(newError) => SetDialogToTimeErrorMsg(getDateTimePickerValidationMsg(newError))}
                                        />

                                    </LocalizationProvider>

                                </Box>
                            </Box> : <Box mt={1}>

                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                    <InputLabel htmlFor="vacation-end-date-input-box" ><Typography color={appThemeColor} variant='body2'>End Date</Typography> </InputLabel>
                                    <DatePicker slotProps={{ textField: { id: 'vacation-end-date-input-box', size: 'small', error: (DialogEndDateErrorMsg !== false), helperText: DialogEndDateErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}
                                        format='MM/DD/YYYY'
                                        minDate={DialogStartDateValue === null ? null : DialogStartDateValue.add(1, 'day')}
                                        value={DialogEndDateValue}

                                        onChange={(value) => SetDialogEndDateValue(value)}
                                        onError={(newError) => SetDialogEndDateErrorMsg(getDateTimePickerValidationMsg(newError))}

                                    />

                                </LocalizationProvider>

                            </Box>}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button variant='contained' startIcon={<CloseIcon />} sx={{ textTransform: 'unset', letterSpacing: -0.3, }} color='error' onClick={() => SetVactionDialogBoxViewStatus(false)}>Cancel</Button>
                    {DialogVacationHeaderName === 'add' && <LoadingButton startIcon={<AddCircleOutlineOutlinedIcon />} loadingPosition='start' color={appThemeSecondaryColor} variant="contained" sx={{ backgroundColor: appThemeColor, textTransform: 'unset', letterSpacing: -0.5, whiteSpace: 'nowrap' }} onClick={() => AddUpdateVacation('add')} loading={DialogAddVactionButtonLoadingStatus}> Add Vacation </LoadingButton>}
                    {DialogVacationHeaderName === 'update' && <LoadingButton startIcon={<UploadOutlinedIcon />} loadingPosition='start' color={appThemeSecondaryColor} variant="contained" sx={{ backgroundColor: appThemeColor, textTransform: 'unset', letterSpacing: -0.5, whiteSpace: 'nowrap' }} onClick={() => AddUpdateVacation('update')} loading={DialogAddVactionButtonLoadingStatus}> Update</LoadingButton>}
                </DialogActions>

            </Dialog>}

        </Box >
    )
}

